
import { parse } from 'libphonenumber-js';

export function isValid_CPFBrazil(value) {
  return !isNaN(value) && value.length>=1;
}
export function isValid_CNPJBrazil(value) {
  return !isNaN(value) && value.length===14;
}
export function isValid_Msisdn(value, country){
  return parse(value, country).phone != undefined && value.length===11;
}


/** WEBPACK FOOTER **
 ** ./src/libs/validators/InputValidator.js
 **/